<template>
    <div>
        <router-view :online="getOnlineUsers.length" :newGoodsBuy="newGoodsBuy" :newRefund="newRefund"></router-view> 
    </div>
</template>
<script>
import { socketio } from '@/components/mixins/socketio.js';
export default {
    name:'widget_counter',
    props:[
        
    ],
    data(){
        return{
            newGoodsBuy:0,
            newRefund:0
        }
    },
    mixins:[socketio],
    components:{

    },
    mounted() {
        this.getGoodsState();
        this.getCount();
    },
    computed:{
        getOnlineUsers(){
            return this.online_users;
        },       
    },
    methods:{
        getGoodsState(){
            this.socket.on("newGoodsState", () => {                
                this.getCount();                
            });
        },
        async getCount()
        {
            try{
                const response =  await this.$store.dispatch("goods/getCount");
                console.log(response); 
                //신규 상품구매 및, 환불 요청
                this.newGoodsBuy = response.goodsBuy;
                this.newRefund = response.refund;
                if(this.newGoodsBuy>0){this.playSound('new_goods_buy');}
                if(this.newRefund>0){this.playSound('new_goods_refund');}
            }catch(error)
            {
                console.log(error);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
